// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e571a16","477":"a640b2ff"}[chunkId] + ".chunk.js";
};